// App.js
// 애플리케이션 루트 컴포넌트. 전역 컨텍스트와 라우팅을 초기화한다.
import "./App.css";
import "./Responsive.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Member/Login";
import Register from "./pages/Member/Register";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./layout";
import Detail from "./pages/Detail/detail"
import Booking from "./pages/Booking/booking"
import TabList from "./pages/List/TabList"
import Search from "./pages/Search/Search"
import { PageTitleProvider } from './contexts/PageTitleContext';
import { AlertProvider } from './contexts/AlertContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import Mypage from "./pages/Mypage/mypage";
import NavigateScrollTop from "./components/Common-components/NavigateScrollTop";
import BestList from "./pages/List/BestList";
import BookMarkList from "./pages/List/BookMarkList";
import FindPassword from "./pages/FindPassword/FindPassword";
import NoticeList from "./pages/Board/NoticeList";
import EventList from "./pages/Board/EventList";
import NoticeDetail from "./pages/Board/NoticeDetail";
import EventDetail from "./pages/Board/EventDetail";
import ReviewList from "./pages/Review/ReviewList";
import ReviewDetail from "./pages/Review/ReviewDetail";
import ReviewWrite from "./pages/Review/ReviewWrite";
// 테스트-페이지
import TestPage from './pages/TestPage';

function App() {
  // 전역 컨텍스트 Provider와 라우팅 트리를 한 곳에서 묶는다.
  return (
    <AlertProvider>
      <PageTitleProvider>
        <FavoritesProvider>
          <Router>
            {/* 라우트 변경 시마다 스크롤을 최상단으로 되돌린다. */}
            <NavigateScrollTop />
            <Routes>
              <Route path="/" element={<Layout />}>
                {/* 메인 홈과 회원 라우트 */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                {/* 상품 상세 및 예약 흐름 */}
                <Route path="/detail/:idx" element={<Detail />} />
                <Route path="/booking/:idx" element={<Booking />} />
                {/* 검색 및 마이페이지 등 기타 페이지 */}
                <Route path="/search" element={<Search />} />
                <Route path="/mypage/*" element={<Mypage />} />
                <Route path="/tablist/*" element={<TabList />} />
                <Route path="/bestlist" element={<BestList />} />
                <Route path="/bookmark" element={<BookMarkList />} />
                <Route path="/forgot-password" element={<FindPassword />} />
                <Route path="/notice" element={<NoticeList />} />
                <Route path="/notice/:id" element={<NoticeDetail />} />
                <Route path="/event" element={<EventList />} />
                <Route path="/event/:id" element={<EventDetail />} />
                <Route path="/review" element={<ReviewList />} />
                <Route path="/review/write" element={<ReviewWrite />} />
                <Route path="/review/:id/edit" element={<ReviewWrite />} />
                <Route path="/review/:id" element={<ReviewDetail />} />
                <Route path="/testpage" element={<TestPage />} />
              </Route>
            </Routes>
          </Router>
        </FavoritesProvider>
      </PageTitleProvider>
    </AlertProvider>
  );
}

export default App;
